import Serializer from "../../serializer";
import { ImportSkillsData } from "./models";

export function serializeImportSkillsData(data: ImportSkillsData) {
  return Serializer.serialize("skills", data);
}
